import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["approveForm", "changesForm"]
  static values = {
    quoteId: String,
    quoteNumber: String
  }

  connect() {
    this.trackQuoteView()
  }

  confirmApproval(event) {
    try {
      const comments = this.approveFormTarget.querySelector('textarea[name="comments"]').value.trim()

      if (comments.length > 0) {
        const confirmed = confirm(
          `You are about to approve this quote${comments ? ' with the following comments:\n\n' + comments : ''}.\n\nThis action cannot be undone. Are you sure?`
        )

        if (!confirmed) {
          event.preventDefault()
          return
        }
      } else {
        const confirmed = confirm(
          "You are about to approve this quote.\n\nThis action cannot be undone. Are you sure?"
        )

        if (!confirmed) {
          event.preventDefault()
          return
        }
      }

      this.trackQuoteApproval();
    } catch (error) {
      console.error("[quote_review]", error, {
        controller: "quote_review",
        action: "confirmApproval",
        quoteId: this.quoteIdValue,
      });
      event.preventDefault();
    }
  }

  confirmChanges(event) {
    try {
      const message = this.changesFormTarget.querySelector('textarea[name="message"]').value.trim()

      if (message.length === 0) {
        const messageInput = this.changesFormTarget.querySelector('textarea[name="message"]');
        if (messageInput) {
          messageInput.focus();
          messageInput.setCustomValidity("Please provide details about the changes you'd like to request.");
          messageInput.reportValidity();
          messageInput.addEventListener('input', () => {
            messageInput.setCustomValidity('');
          }, { once: true });
        }
        event.preventDefault()
        return
      }

      const confirmed = confirm(
        `You are about to request changes to this quote with the following message:\n\n${message}\n\nAre you sure?`
      )

      if (!confirmed) {
        event.preventDefault()
        return
      }

      this.trackQuoteChanges();
    } catch (error) {
      console.error("[quote_review]", error, {
        controller: "quote_review",
        action: "confirmChanges",
        quoteId: this.quoteIdValue,
      });
      event.preventDefault();
    }
  }

  trackQuoteView() {
    if (typeof gtag === 'function') {
      gtag('event', 'view_quote', {
        quote_id: this.quoteIdValue,
        quote_number: this.quoteNumberValue
      })
    }
  }

  trackQuoteApproval() {
    if (typeof gtag === 'function') {
      gtag('event', 'approve_quote', {
        quote_id: this.quoteIdValue,
        quote_number: this.quoteNumberValue
      })
    }
  }

  trackQuoteChanges() {
    if (typeof gtag === 'function') {
      gtag('event', 'request_quote_changes', {
        quote_id: this.quoteIdValue,
        quote_number: this.quoteNumberValue
      })
    }
  }
}